module.exports = __webpack_public_path__ + "static/PosteriorCore-BirdDog-c466a4cd7ea77c35553d40e1e8985acb.mp4";